import { FC } from "react";

import { isFuture, isWithinInterval } from "date-fns";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Counter from "components/Counter";
import GridItem from "components/Grid/GridItem";
import BackArrow from "components/BackArrow";
import { COUNTER_SIZES } from "components/Counter/sizes";

import { APP_ROUTES } from "config/routes";

import { Client } from "services/store/Store.interface";

import styles from "./styles";
interface StoreDetailsProps {
  details: Pick<
    Client,
    "name" | "description" | "startSellingDate" | "endDate" | "isCreatedByForm"
  >;
  socialsComponent?: JSX.Element | JSX.Element[];
  isEmbedded?: boolean;
}

const StoreDetails: FC<StoreDetailsProps> = ({
  details,
  socialsComponent,
  isEmbedded,
}) => {
  return (
    <Box sx={styles.container}>
      {!isEmbedded && (
        <GridItem
          sx={{
            py: { xs: 2, sm: 0 },
            mb: 2,
            order: { xs: 99, sm: 0 },
          }}
        >
          <BackArrow
            path={APP_ROUTES.STORES}
            label="Back to stores list"
            mb={0}
          />
        </GridItem>
      )}
      <Box sx={styles.wrapper}>
        <Typography
          sx={{ mt: 3 }}
          component="h3"
          variant="h3"
          justifyContent="center"
          display="flex"
        >
          {details?.name}
        </Typography>
        {socialsComponent}
        <Typography
          justifyContent="center"
          display="flex"
          textAlign="center"
          maxWidth="1000px"
          mx="auto"
          sx={{
            mt: { xs: 0, md: 4 },
            mb: { xs: 2, md: 5 },
            whiteSpace: "pre-line",
          }}
          {...(details?.isCreatedByForm
            ? {
                children: details?.description,
              }
            : {
                dangerouslySetInnerHTML: {
                  __html: details?.description,
                },
              })}
        />
        {details?.startSellingDate &&
          isFuture(new Date(details.startSellingDate)) && (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              mb={3}
            >
              <Typography
                justifyContent="center"
                display="flex"
                maxWidth="1000px"
                mx="auto"
                align="center"
                variant="h4"
                component="h4"
                fontWeight={400}
                mb={2}
              >
                {details.name} starts in:
              </Typography>
              <Counter
                size={COUNTER_SIZES.LARGE}
                time={details.startSellingDate}
              />
            </Box>
          )}
        {details?.endDate &&
          details?.startSellingDate &&
          isWithinInterval(new Date(), {
            start: new Date(details.startSellingDate),
            end: new Date(details.endDate),
          }) && (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              mb={5}
            >
              <Typography
                justifyContent="center"
                display="flex"
                maxWidth="1000px"
                mx="auto"
                align="center"
                variant="h4"
                component="h4"
                fontWeight={400}
                mb={2}
              >
                {details?.name} ends in
              </Typography>
              <Counter size={COUNTER_SIZES.LARGE} time={details.endDate} />
            </Box>
          )}
      </Box>
    </Box>
  );
};

export default StoreDetails;
